/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitSignaturePolicy
*/
export var KitSignaturePolicy;
(function (KitSignaturePolicy) {
    KitSignaturePolicy["OFF"] = "OFF";
    KitSignaturePolicy["WARN"] = "WARN";
    KitSignaturePolicy["REQUIRED"] = "REQUIRED";
})(KitSignaturePolicy || (KitSignaturePolicy = {}));
//# sourceMappingURL=KitSignaturePolicy.js.map